<template>
    <div style="position: absolute; top:0; right: 0;height: 100%">
        <div style="height: 100%;position: relative">
            <side-panel-menu
                    style="width:60px"
                    :menuItems="menuItems"
                    :defaultSelectedMenuItem="selectedItem"
                    :defaultIsOpen="defaultMenuIsOpen"
                    @menuStateChanged="onMenuStateChanged"
            >
                <slot name="menu-bottom"></slot>
            </side-panel-menu>
            <slide-panel
                    style="height: 100%; position: absolute; right: -340px;top: 0; width: 400px;transition: right .40s ease"
                    :style="{'right':isMenuOpen?'60px':'-340px'}"
                    :items="menuItems"
                    :selectedItem="selectedItem"
            >
                <template v-for="{id} in menuItems">
                    <div :slot="id" style="width: 100%;height: 100%">
                        <slot :name="id"></slot>
                    </div>
                </template>
            </slide-panel>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    import SidePanelMenu from './side-panel-menu'
    import SlidePanel from './slide-panel'

    export default {
        props: {
            menuItems: {
                type: Array,
                default: () => []
            },
            selectedItem: {
                type: Number,
                default: null
            },
            defaultMenuIsOpen: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isMenuOpen: this.defaultMenuIsOpen
            }
        },
        computed: {},
        methods: {
            onMenuStateChanged: function (isOpen, selectedItem) {
                this.isMenuOpen = isOpen;
                this.updateSelectedItem(selectedItem);
            },
            updateSelectedItem(val) {
                this.$emit('update:selectedItem', val);
            }
        },

        components: {
            SidePanelMenu,
            SlidePanel
        }

    }
</script>

<style scoped>

</style>
